import BlogsNews from '@shared/components/olympics/blogsNews'
import LatestArticles from '@shared/components/olympics/latestArticles'
import OlympicsTrendingNews from '@shared/components/olympics/olympicsTrendingNews'
import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import { Col, Container, Row } from 'react-bootstrap'
import MedalTable from '@shared/components/olympics/medalTable'
import Mascots from '@shared/components/olympics/mascots'
import queryGraphql from '@shared/components/queryGraphql'
import { handleApiError, parallelCalls } from '@shared-submodule/utils'
// import { TRENDING_NEWS } from '@graphql/home/home.query'
import SportsTable from '@shared/components/olympics/sportsTable'
import { GET_CATEGORY_NEWS_VIDEOS } from '@graphql/series/home.query'
import OlympicsHeader from '@shared/components/olympics/olympicsHeader'
import Venues from '@shared/components/olympics/olympicsVenues'
import HighlightArticle from '@shared/components/olympics/olympicsHighlights'
import OlympicTimeline from '@shared/components/olympics/olympicsTimeline'
import InterestingReads from '@shared/components/olympics/olympicsInterestingReads'
import Layout from '@shared/components/layout'
import styles from './styles.module.scss'
import { GET_OLYMPICS_STATS } from '@graphql/olympics/table.query'
import { GET_SEO_DATA } from '@graphql/article/article.query'

// import { googleAddData } from '@shared-submodule/sm-constants/googleAdsData'
// import Error from '@shared/components/error'
// import Layout from '@shared/components/layout'
// import { GET_SEO_DATA } from '@graphql/article/article.query'
// import { checkRedirectionStatus, handleApiError } from '@shared-submodule/utils'
//
import { reviveAdData } from '@shared/components/reviveAds/reviveAdData'

// const GoogleAds = dynamic(() => import('@shared-submodule/sm-components/googleAds'), { ssr: false })
const ReviveAds = dynamic(() => import('@shared/components/reviveAds'), { ssr: false })
function Olympics({ news, medal, seoData }) {
  const data = news?.listSimpleCategoryArticlesVideosFront?.oArticles
  const { addTop, mobSm } = reviveAdData
  return (
    <Layout
      data={{
        oSeo: seoData?.getSeoData
      }}>
      <>
        <OlympicsHeader />
        <Container>
          <div className="w-full d-none d-md-flex justify-content-center ">
            {/* <GoogleAds
              addId={googleAddData?.addTop?.addId}
              divId={googleAddData?.addTop?.divId}
              dimension={googleAddData?.addTop?.dimension}
              slotId={googleAddData?.addTop?.slotId}
            /> */}
            <ReviveAds {...addTop} className={'my-2'} />
          </div>
          <div className="w-full d-flex d-md-none justify-content-center mt-4">
            {/* <GoogleAds
              addId={googleAddData?.mobSm?.addId}
              divId={googleAddData?.mobSm?.divId}
              dimension={googleAddData?.mobSm?.dimension}
              slotId={googleAddData?.mobSm?.slotId}
              className={'mt-3'}
            /> */}
            <ReviveAds {...mobSm} className={'mt-3'} />
          </div>
          <div className="d-flex flex-column gap-4">
            <Row className={styles.gap}>
              <Col md={3} className={`${styles.order}`}>
                {data?.aResults && <OlympicsTrendingNews data={data?.aResults?.slice(0, 8)} />}
              </Col>
              <Col md={6} className={`${styles.centerContent}`}>
                {data?.aResults && <LatestArticles data={data?.aResults?.slice(8, 10)} />}
              </Col>
              <Col md={3} className="common-sidebar mt-0">
                {medal && <MedalTable data={medal} />}
              </Col>
            </Row>
            <OlympicTimeline />
            {data?.aResults && <HighlightArticle article={data?.aResults?.[11]} />}
            <Mascots />
            <Venues />
            <InterestingReads />
            <Row>
              <Col md={9}>{data?.aResults && <BlogsNews data={data?.aResults?.slice(16, 22)} />}</Col>
              <Col md={3}>
                <SportsTable />
              </Col>
            </Row>
          </div>
        </Container>
      </>
    </Layout>
  )
}

export async function getServerSideProps({ res, resolvedUrl }) {
  try {
    res.setHeader('Cache-Control', 'public, max-age=600')
    const { data: seoData } = await queryGraphql(GET_SEO_DATA, { input: { sSlug: 'olympics' } })
    // const { data: news } = await queryGraphql(GET_CATEGORY_NEWS_VIDEOS, {
    //   input: {
    //     nLimit: 60,
    //     nSkip: 0,
    //     iCategoryId: '66067385c8d2f96e9a4d5240',
    //     eType: 'vn'
    //   }
    // })
    // const { data: medal } = await queryGraphql(GET_OLYMPICS_STATS, {
    //   input: {
    //     nYear: 2020
    //   }
    // })
    const [news, medal] = await parallelCalls([
      queryGraphql(GET_CATEGORY_NEWS_VIDEOS, {
        input: {
          nLimit: 60,
          nSkip: 0,
          iCategoryId: '66067385c8d2f96e9a4d5240',
          eType: 'vn'
        }
      }),
      queryGraphql(GET_OLYMPICS_STATS, {
        input: {
          nYear: 2024
        }
      })
    ])

    return {
      props: {
        news,
        medal: medal.getOlympicsStats,
        seoData
      }
    }
  } catch (e) {
    console.error('Error fetching data:', e)
    res.setHeader('Cache-Control', 'no-cache')
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}

Olympics.propTypes = {
  news: PropTypes.object,
  medal: PropTypes.object,
  seoData: PropTypes.object
}

export default Olympics
